import { dedupePerformanceEntries } from '../util/dedupePerformanceEntries.js';
/**
 * Sets up a PerformanceObserver to listen to all performance entry types.
 */

function setupPerformanceObserver(replay) {
  var performanceObserverHandler = function performanceObserverHandler(list) {
    // For whatever reason the observer was returning duplicate navigation
    // entries (the other entry types were not duplicated).
    var newPerformanceEntries = dedupePerformanceEntries(replay.performanceEvents, list.getEntries());
    replay.performanceEvents = newPerformanceEntries;
  };

  var performanceObserver = new PerformanceObserver(performanceObserverHandler);
  ['element', 'event', 'first-input', 'largest-contentful-paint', 'layout-shift', 'longtask', 'navigation', 'paint', 'resource'].forEach(function (type) {
    try {
      performanceObserver.observe({
        type: type,
        buffered: true
      });
    } catch (e) {// This can throw if an entry type is not supported in the browser.
      // Ignore these errors.
    }
  });
  return performanceObserver;
}

export { setupPerformanceObserver };